/* eslint-disable camelcase */
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.MultipleChoice.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.MultipleChoice.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.title_container = null;
  this.question_container = null;
  this.answers = [];
};

EDC.Games.MultipleChoice.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.MultipleChoice.Scenes.Main.prototype.constructor = EDC.Games.MultipleChoice.Scenes.Main;

const MC = EDC.Games.MultipleChoice.Scenes.Main.prototype;

MC.create = function () {
  this.initialize();

  this.loadIteration();

  this.createBasicUI();
};

MC.loadIteration = function () {
  this.createTitle();
  this.createQuestion();
  this.createAnswers();
  this.createAnimations(this.title_container, this.question_container, this.answers);
};

MC.createAnimations = function (title, question, answers) {
  // title
  title.init_y = title.y;
  title.y = -600;
  this.tweens.add({
    targets: title,
    y: title.init_y,
    duration: 1500,
    ease: 'Sine.easeInOut',
  });

  // question
  question.init_x = question.x;
  question.x = -1500;
  this.tweens.add({
    targets: question,
    x: question.init_x,
    duration: 1500,
    ease: 'Sine.easeInOut',
  });

  // answers
  answers.map((answer) => {
    answer.init_x = answer.x;
    answer.x = answer.init_x + 1500;
    this.tweens.add({
      targets: answer,
      x: answer.init_x,
      duration: 1500,
      ease: 'Sine.easeInOut',
    });
  });
};

MC.createAnswers = function () {
  const { answers } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  // eslint-disable-next-line max-len
  let { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer;
  correctAnswer -= 1;
  for (let i = 0; i < answers.length; i++) {
    const answer_container = this.add.container(0, 0);
    answer_container.name = 'answer';
    answer_container.asset_key = this.gameConfig.assets.answer_numbers[i].key;
    answer_container.x = this.game.config.width / 2;
    // eslint-disable-next-line max-len
    answer_container.y = this.question_container.y + this.question_container.displayHeight + this.gameConfig.answerTopMargin + i * (this.gameConfig.answerFrameConfigurable.height + this.gameConfig.answerTopMargin);
    this.createFrame(answer_container);
    this.createAnswer(answer_container, answers[i]);
    if (i === correctAnswer) {
      answer_container.isCorrect = true;
    } else {
      answer_container.isCorrect = false;
    }
    const hit_area_rectangle = new Phaser.Geom.Rectangle(
      0,
      answer_container.displayHeight / 2,
      answer_container.displayWidth,
      answer_container.displayHeight,
    );

    answer_container.setInteractive(hit_area_rectangle, Phaser.Geom.Rectangle.Contains);
    const markAnim = new AnswerMark(this, answer_container).setScale(0.15);
    answer_container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(answer_container);
    answer_container.on('pointerup', this.checkAnswer.bind(this, answer_container));
    this.answers.push(answer_container);
  }
};

MC.checkAnswer = function (container) {
  if (container.isCorrect) {
    this.playCorrect();
    this.answers.map(x => x.disableInteractive());
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    container.disableInteractive();
    this.playWrong();
    container.iterate((x) => {
      x.setTint(0xff0000);
    });
  }
};

MC.nextIteration = function () {
  this.title_container.destroy();
  this.title_container = null;

  this.question_container.destroy();
  this.question_container = null;
  this.answers.map(answer => answer.destroy());
  this.answers = [];

  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

MC.createAnswer = function (container, answer) {
  const frame = this.add
    .sprite(-container.displayWidth / 2, 0, 'answer_numbers_frame_image')
    .setOrigin(0.5)
    .setScale(1.1);
  frame.x += frame.displayWidth / 2;
  frame.y += frame.displayHeight / 2;
  const number = this.add.sprite(0, 0, `answer_numbers_${container.asset_key}`).setOrigin(0.5);
  number.x = frame.x;
  number.y = frame.y;
  const font = {
    font: `${this.gameConfig.answerTextSize} ${this.gameConfig.answerTextFont}`,
  };
  const text = this.add.text(0, container.displayHeight / 2, answer, font).setOrigin(0.5);
  container.add([frame, number, text]);
};

MC.createTitle = function () {
  this.title_container = this.add.container(this.game.config.width / 2,
    this.gameConfig.titleTopMargin);
  this.title_container.name = 'title';
  this.createFrame(this.title_container);
  this.fillTitleFrame(this.title_container);
};

MC.createQuestion = function () {
  this.question_container = this.add.container(
    this.game.config.width / 2,
    this.title_container.y + this.title_container.displayHeight + this.gameConfig.questionTopMargin,
  );
  this.question_container.name = 'question';
  this.createFrame(this.question_container);
  this.fillQuestionFrame(this.question_container);
};

MC.fillQuestionFrame = function (container) {
  const text = this.make.text({
    x: 0,
    y: container.displayHeight / 2,
    text: this.gameConfig.sets[this.difficulty].iterations[this.iteration].question,
    origin: { x: 0.5, y: 0.5 },
    style: {
      font: `${this.gameConfig.questionTextSize} ${this.gameConfig.questionTextFont}`,
      wordWrap: { width: container.displayWidth * 0.9 },
    },
  });
  container.add(text);
};

MC.fillTitleFrame = function (container) {
  let object;
  const { titleText } = this.gameConfig;
  const isPng = '.png';
  if (titleText) {
    if (titleText.includes(isPng)) {
      object = this.add.sprite(0, 0, 'title');
    } else {
      const objectFont = {
        font: `${this.gameConfig.titleTextSize} ${this.gameConfig.titleTextFont}`,
      };
      object = this.add.text(0, 0, this.gameConfig.titleText, objectFont);
    }
    object.y = container.displayHeight / 2;
    object.setOrigin(0.5);
    container.add(object);
  }
};

MC.createFrame = function (object) {
  if (this.gameConfig[`${object.name}FrameImage`]) {
    const frame = this.add.sprite(0, 0, `${object.name}_frame_image`);
    frame.x = frame.displayWidth / 2;
    object.add(frame);
    object.setSize(frame.displayWidth, frame.displayHeight);
  } else if (this.gameConfig[`${object.name}FrameConfigurable`].imageKit) {
    this.createFromImageKit(object);
  }
};

MC.createFromImageKit = function (object) {
  const frame_width = this.gameConfig[`${object.name}FrameConfigurable`].width;
  const frame_height = this.gameConfig[`${object.name}FrameConfigurable`].height;
  const key = `imageKit_${object.name}_frames_`;

  const corner_top_left = this.add.sprite(0, 0, `${key}corner_top_left`);
  corner_top_left.x = -frame_width / 2;
  corner_top_left.y = 0;

  const corner_top_right = this.add.sprite(0, 0, `${key}corner_top_right`);
  corner_top_right.x = frame_width / 2 - corner_top_right.displayWidth;
  corner_top_right.y = 0;

  const corner_bottom_left = this.add.sprite(0, 0, `${key}corner_bottom_left`);
  corner_bottom_left.x = -frame_width / 2;
  corner_bottom_left.y = frame_height - corner_bottom_left.displayHeight;

  const corner_bottom_right = this.add.sprite(0, 0, `${key}corner_bottom_right`);
  corner_bottom_right.x = frame_width / 2 - corner_bottom_right.displayWidth;
  corner_bottom_right.y = frame_height - corner_bottom_right.displayHeight;

  const mid_left = this.add.sprite(0, 0, `${key}mid_left`);
  mid_left.x = corner_top_left.x - 1;
  mid_left.y = corner_top_left.displayHeight;
  // eslint-disable-next-line max-len
  mid_left.displayHeight = corner_bottom_left.y - (corner_top_left.y + corner_top_left.displayHeight);

  const mid_right = this.add.sprite(0, 0, `${key}mid_right`);
  mid_right.x = corner_top_right.x - 5;
  mid_right.y = corner_top_right.displayHeight;
  // eslint-disable-next-line max-len
  mid_right.displayHeight = corner_bottom_right.y - (corner_top_right.y + corner_top_right.displayHeight);

  const mid_top = this.add.sprite(0, 0, `${key}mid_top`);
  mid_top.x = corner_top_left.x + corner_top_left.displayWidth;
  mid_top.y = 0;
  mid_top.displayWidth = corner_top_right.x - (corner_top_left.x + corner_top_left.displayWidth);

  const mid_bottom = this.add.sprite(0, 0, `${key}mid_bottom`);
  mid_bottom.x = corner_bottom_left.x + corner_bottom_left.displayWidth;
  mid_bottom.y = frame_height - mid_bottom.displayHeight;
  // eslint-disable-next-line max-len
  mid_bottom.displayWidth = corner_bottom_right.x - (corner_bottom_left.x + corner_bottom_left.displayWidth);

  const center = this.add.sprite(0, 0, `${key}center`);
  center.x = corner_top_left.x + corner_top_left.displayWidth / 2;
  center.displayWidth = corner_top_right.x - corner_top_left.x;
  center.displayHeight = corner_bottom_left.y - corner_top_left.y;

  object.add([
    center,
    corner_top_left,
    corner_top_right,
    corner_bottom_left,
    corner_bottom_right,
    mid_left,
    mid_right,
    mid_top,
    mid_bottom,
  ]);
  const container_width = corner_top_right.x + corner_top_right.displayWidth - corner_top_left.x;
  // eslint-disable-next-line max-len
  const container_height = corner_bottom_right.y + corner_bottom_right.displayHeight - corner_top_right.y;

  object.setSize(container_width, container_height);
  object.each((child) => {
    child.setOrigin(0, 0);
  });
};

export default EDC.Games.MultipleChoice.Scenes.Main;
